import React from "react";
import Routes from "./components/utils/Routes";
import "./App.scss";
import { ToastContainer } from "react-toastify";
import { AppDiv } from "./components/styled-components";
import { useSelector } from "react-redux";

const App = () => {
  const state = useSelector((state) => state.sharer);
  const whitelabel =
    state.readyMadeData && state.readyMadeData.whitelabel
      ? state.readyMadeData.whitelabel
      : {};

  return (
    <AppDiv color={whitelabel.textColor} font={whitelabel.fontFamily}>
      <ToastContainer limit={5} />
      <Routes />
    </AppDiv>
  );
};

export default App;
